import { environment as base } from './environment.common';

export const environment = {
  ...base,
  production: true,
  defaultServerConfig: {
    urls: {
      api: 'https://api.dev.kaizenep.com',
      db: 'https://dev.kaizenep.com/db',
      auth: 'https://titty.dev.kaizenep.com',
      epf: 'https://dev.kaizenep.com',
      org: 'https://org.devin.kaizenep.com',
    },
    oidc: {
      authority: 'https://auth.dev.kaizenep.com',
      client_id: 'eas',
      response_type: 'id_token token',
      scope: 'openid email',
      redirect_uri: 'https://booking.dev.kaizenep.com/auth-callback',
    },
    liveChat: {
      licenses: {}
    },
    sentry: undefined,
  }};
